<template>
    <form v-on:submit.prevent="onSubmit">
        <loading :loading="loading"></loading>
        <div class="row justify-content-center">
            <div class="basicinfo col-lg-8">

                <!--DATE-->
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="date">Date</label>
                        <datepicker v-model="date" :format="customFormatter" id="date"></datepicker>
                    </div>

                    <div class="form-group col-md-3">
                        <label for="sid">Starting id</label>
                        <input type="text" v-model="transactionId" required id="sid" class="form-control"/>
                    </div>
                </div>

                <!--BASE ASSET-->
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="asset">Base asset</label>
                        <multiselect
                                id="asset"
                                v-model="baseAsset"
                                :options="baseAssets"
                                label="format" track-by="name"
                                @select="onSelectBaseAsset"
                                :allow-empty="false"
                                deselect-label="" select-label=""
                        ></multiselect>
                    </div>

                    <!--ASSETS 2-->
                    <div class="form-group col-md-6">
                        <label for="assets">Assets 2</label>
                        <multiselect
                                id="assets"
                                v-model="pricesSelect"
                                :options="pricesSelectArr"
                                label="format" track-by="id"
                                :multiple="true"
                                @select="onSelectPrice"
                                @remove="onRemovePrice"
                                select-label=""
                                :disabled="!baseAsset"
                        ></multiselect>
                    </div>
                </div>

                <!--CLIENTS-->
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="clients">Clients</label> <a
                            href="#"
                            v-on:click.stop="checkAll">{{ selectall }}</a>({{ checkedCount }}）
                        <multiselect
                                id="clients"
                                v-model="clientsSelect"
                                :options="clientsSelectArr"
                                :multiple="true"
                                label="fullName" track-by="id"
                                @select="onSelectClient"
                                @remove="onRemoveClient"
                                select-label=""
                                :disabled="!baseAsset || !pricesSelect"
                        ></multiselect>
                    </div>

                    <div class="form-group col-md-6">
                        <label for="remark">Remark</label>
                        <textarea id="remark" class="form-control" v-model="remark"></textarea>
                    </div>
                </div>
            </div>
        </div>

        <!--TABLE-->
        <div class="row mt-5" v-if="tableValues[0].isSelected">
            <h1 class="h2">Input transactions</h1>
            <table class="table text-center inputtrans">
                <thead>
                <tr>
                    <th scope="col" style="width: 1px;">Asset</th>
                    <th scope="col" style="width: 200px;">Before</th>
                    <th scope="col" style="width: 200px;">CCY1</th>
                    <th scope="col" style="width: 200px;">CCY2</th>
                    <th scope="col" style="width: 250px;">Exchange fee</th>
                    <th scope="col" style="width: 1px;">FX</th>
                    <th scope="col" style="width: 200px;">B Fee</th>
                    <th scope="col" style="width: 250px;">After</th>
                    <th scope="col" style="width: 250px;">Cold storage</th>
                </tr>
                </thead>
                <tbody>
                <!--ROWS-->
                <tr v-for="(values, index) in tableValues" :key="values.baseAsset">
                    <!--FIRST-->
                    <template v-if="!index">
                        <th scope="row">{{ values.baseAsset }}</th>
                        <td>
                            <span class="btn-group mt-1" style="vertical-align: text-top;">{{ customFixed(values.before) }}
                                <b-button size="sm" variant="light" class="ml-2 copytoclip" v-b-tooltip.hover
                                          :title="parseFloat(values.before).toFixed(14)" v-on:click.stop="copyToClipboard(parseFloat(values.before).toFixed(14))">
                                    <span>...</span><span style="width: 100%;text-align: left;">&#128203;</span>
                                </b-button>
                            </span>
                        </td>
                        <td v-bind:class="{ 'table-warning': values.checkLTE }">{{ customFixed(values.ccy1) }}</td>
                        <td>N/A</td>
                        <td>0</td>
                        <td>1</td>
                        <td>
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <span class="input-group-text">{{ values.baseAsset }}</span>
                                </div>
                                <input type="text" class="form-control text-right w-100"
                                       v-model.number="values.blockchainFee" @input="onInput" @keydown="onInput"
                                       @blur="onInput">
                            </div>
                        </td>
                        <td v-bind:class="{ 'table-danger': values.checkneg }">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <span class="input-group-text">{{ values.baseAsset }}</span>
                                </div>
                                <div class="form-control d-flex justify-content-end w-100">
                                    {{customFixed(values.after)}}
                                </div>
                                <div class="input-group-addon bg-light">
                                    <span v-if="values.check" style="color: transparent; text-shadow: 0 0 0 green;">&#10004;</span>
                                    <span v-if="!values.check" style="color: transparent; text-shadow: 0 0 0 red;">&#10006;</span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <span class="input-group-text">{{ values.baseAsset }}</span>
                                </div>
                                <input type="text" class="form-control text-right w-100"
                                       v-model.number="values.coldStorage" @input="onInput" @keydown="onInput"
                                       @blur="onInput">
                                <div class="input-group-addon bg-light">
                                    <span v-if="values.csCheck" style="color: transparent; text-shadow: 0 0 0 green;">&#10004;</span>
                                    <span v-if="!values.csCheck" style="color: transparent; text-shadow: 0 0 0 red;">&#10006;</span>
                                </div>
                            </div>
                        </td>
                    </template>
                    <!--REMAINING-->
                    <template v-else>
                        <th scope="row">{{ values.baseAsset }}</th>
                        <td>
                            <span class="btn-group mt-1" style="vertical-align: text-top;">{{ parseFloat(values.before).toFixed(8) }}
                                <b-button size="sm" variant="light" class="ml-2 pull-right copytoclip" v-b-tooltip.hover
                                          :title="parseFloat(values.before).toFixed(14)" v-on:click.stop="copyToClipboard(parseFloat(values.before).toFixed(14))">
                                    <span>...</span><span style="width: 100%;text-align: left;">&#128203;</span>
                                </b-button>
                            </span>
                        </td>
                        <td>
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <span class="input-group-text">{{ values.baseAsset }}</span>
                                </div>
                                <input type="text" class="form-control text-right w-100" v-model.number="values.ccy1"
                                       @input="onInput" @keydown="onInput" @blur="onInput">
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <span class="input-group-text">{{ tableValues[0].baseAsset }}</span>
                                </div>
                                <input type="text" class="form-control text-right w-100" v-model.number="values.ccy2"
                                       @input="onInput" @keydown="onInput" @blur="onInput">
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <multiselect
                                        class="exchangefee"
                                        v-model="values.exchangeFeeValue"
                                        :options="values.exchangeFeeOptions"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        :searchable="false"
                                        @input="onInput"
                                ></multiselect>
                                <input type="text" class="form-control text-right w-100"
                                       v-model.number="values.exchangeFee" @input="onInput" @keydown="onInput"
                                       @blur="onInput">
                            </div>
                        </td>
                        <td>
                            {{ customFixed(values.fx) }}
                        </td>
                        <td>
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <span class="input-group-text">{{ values.baseAsset }}</span>
                                </div>
                                <input type="text" class="form-control text-right w-100"
                                       v-model.number="values.blockchainFee" @input="onInput" @keydown="onInput"
                                       @blur="onInput">
                            </div>
                        </td>
                        <td v-bind:class="{ 'table-danger': values.checkneg }">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <span class="input-group-text">{{ values.baseAsset }}</span>
                                </div>
                                <div class="form-control d-flex justify-content-end w-100">{{ values.after.toFixed(8) }}
                                </div>
                                <div class="input-group-addon bg-light">
                                    <span v-if="values.check" style="color: transparent; text-shadow: 0 0 0 green;">&#10004;</span>
                                    <span v-if="!values.check" style="color: transparent; text-shadow: 0 0 0 red;">&#10006;</span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <span class="input-group-text">{{ values.baseAsset }}</span>
                                </div>
                                <input type="text" class="form-control text-right w-100"
                                       v-model.number="values.coldStorage" @input="onInput" @keydown="onInput"
                                       @blur="onInput">
                                <div class="input-group-addon bg-light">
                                    <span v-if="values.csCheck" style="color: transparent; text-shadow: 0 0 0 green;">&#10004;</span>
                                    <span v-if="!values.csCheck" style="color: transparent; text-shadow: 0 0 0 red;">&#10006;</span>
                                </div>
                            </div>
                        </td>
                    </template>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="row pt-3">
          <div class="col d-flex justify-content-start"> </div>
          <div class="col d-flex justify-content-end"><b>Client level check:</b>&nbsp;
            <span v-if="checkbaseasseteq"
                  style="color: transparent; text-shadow: 0 0 0 green;">&#10004;</span>
            <span v-if="!checkbaseasseteq"
                  style="color: transparent; text-shadow: 0 0 0 red;">&#10006;</span>
          </div>
          <div class="col d-flex justify-content-end"> </div>
        </div>
        <!--TABLES-->
        <div class="list-group-item row mt-3" v-for="(values, index) in getClients">
            <div class="row pt-3">
                <div class="col d-flex justify-content-start">{{ values.fullName }}</div>
                <div class="col d-flex justify-content-end">
                    {{ customFixed(values.details.baseAssetEqual) }} {{ values.details.assets[baseAsset.ticker].ticker }}&nbsp;&nbsp;&nbsp;
                  <span v-if="values.details.baseAssetCheck"
                        style="color: transparent; text-shadow: 0 0 0 green;">&#10004;</span>
                  <span v-if="!values.details.baseAssetCheck"
                        style="color: transparent; text-shadow: 0 0 0 red;">&#10006;</span>

                </div>
                <div class="col d-flex justify-content-end">
                    {{ parseFloat(values.details.percentage * 100).toFixed(4) }}%
                </div>
            </div>
            <table class="table text-center table-striped">
                <thead>
                <tr>
                    <th scope="col">Asset</th>
                    <th scope="col">Before</th>
                    <th scope="col">CCY1 Amount</th>
                    <th scope="col">CCY2 Amount</th>
                    <th scope="col">FX</th>
                    <th scope="col">B Fee</th>
                    <th scope="col">After</th>
                    <th scope="col">Check</th>
                </tr>
                </thead>
                <tbody>
                <!--FIRST ROW-->
                <tr>
                    <th scope="row">{{ tableValues[0].baseAsset }}</th>
                    <td>{{ customFixed(values.details.baseAssetPieces) }}</td>
                    <td>N/A</td>
                    <td>
                        <span v-if="values.details.ccy2"
                              style="color: transparent; text-shadow: 0 0 0 green;">&#10004;</span>
                        <span v-if="!values.details.ccy2"
                              style="color: transparent; text-shadow: 0 0 0 red;">&#10006;</span>
                    </td>
                    <td>1</td>
                    <td>{{ customFixed(values.details.blockchainFee) }}</td>
                    <td>{{ parseFloat(values.details.after).toFixed(8) }}</td>
                    <td></td>
                </tr>
                <!--ROWS-->
                <tr v-for="(prices, i) in getPrices">
                    <th scope="row">{{ prices.symbol }}</th>
                    <td>{{ parseFloat(values.details.pricesPieces[i]).toFixed(8) }}</td>
                    <td>{{ customFixed(values.details.ccy1Arr[i]) }}</td>
                    <td>{{ parseFloat(values.details.ccy2Arr[i]).toFixed(8) }}</td>
                    <td>{{ customFixed(values.details.fxArr[i]) }}</td>
                    <td>{{ customFixed(values.details.blockchainFees[i]) }}</td>
                    <td>{{ parseFloat(values.details.afters[i]).toFixed(8) }}</td>
                    <td>
                        <span v-if="values.details.afterCheck" style="color: transparent; text-shadow: 0 0 0 green;">&#10004;</span>
                        <span v-if="!values.details.afterCheck" style="color: transparent; text-shadow: 0 0 0 red;">&#10006;</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!--    {{uploads}}-->

        <!--CSV TABLE-->
        <div class="list-group-item row mt-5" v-if="canSubmit">
            <h1 class="h3">Rebalance CSV Preview</h1>
            <table class="table text-center">
                <thead>
                <template v-for="(row, index) in getCsvTable">
                    <tr v-if="!index">
                        <th scope="col" v-for="col in row">{{ col }}</th>
                    </tr>
                </template>
                </thead>
                <tbody>
                <template v-for="(row, index) in getCsvTable">
                    <tr v-if="index" v-bind:class="{ 'table-active': csvBreakpoints[index] }">
                        <td v-for="col in row">{{ col }}</td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>

        <div class="row mt-5 justify-content-center">
            <div class="form-group mr-4">
                <button :disabled="!canSubmit || !date" class="btn btn-outline-success">Submit transactions</button>
            </div>
            <div class="form-group mr-4">
                <button @click="downloadCSV" :disabled="!canSubmit || !date" class="btn btn-outline-success">Download
                    Rebalance CSV
                </button>
            </div>
            <div class="form-group mr-4">
                <button @click="downloadTransactions" :disabled="!canSubmit || !date" class="btn btn-outline-success">
                    Download Input Transactions CSV
                </button>
            </div>
        </div>
    </form>
</template>


<script>
  import axios from 'axios'
  import Datepicker from 'vuejs-datepicker'
  import Multiselect from 'vue-multiselect'
  // import Decimal from 'decimal.js'
  import BigNumber from 'bignumber.js'
  import moment from 'moment'
  import Papa from 'papaparse'
  import FileSaver from 'file-saver'
  import uploadService from '../../services/uploadService'

  const API_V1_URL = process.env.API_V1_URL
  BigNumber.config({ EXPONENTIAL_AT: 20, ROUNDING_MODE: BigNumber.ROUND_HALF_UP })
  // BigNumber.DEBUG = true
  /* Decimal.set({ rounding: 5 }) */
  // Decimal.set({toExpNeg: -14, precision: 20})

  /* eslint-disable no-multiple-empty-lines */
  /* eslint-disable no-trailing-spaces */
  export default {
    components: {
      Datepicker,
      Multiselect,
    },
    data() {
      return {
        loading: false,
        canSubmit: false,
        transactionId: '',
        date: '',
        // Objects to keep in memory
        assets: {},
        clients: {},
        currencies: {},
        // Select value
        baseAsset: null,
        baseAssets: [],
        portfolios: {},
        pricesSelect: null,
        pricesSelectArr: [],
        clientsSelect: null,
        clientsSelectArr: [],
        checkedRoles: [],
        // Table values
        tableValues: [{
          isSelected: false,
          checkLTE: false,
          baseAsset: '',
          before: 0,
          ccy1: 0,
          ccy2: 0,
          exchangeFee: 0,
          fx: 0,
          blockchainFee: 0,
          after: 0,
          coldStorage: 0,
          csCheck: '',
          check: '',
          checkneg: false,
        }],
        checkbaseasseteq: true,
        remark: '',
        computedClients: [],
        csvBreakpoints: null,
      }
    },
    computed: {
      checkedCount() {
        if (this.clientsSelect) {
          return this.clientsSelect.length
        } else {
          return 0
        }
      },
      selectall() {
        if (this.clientsSelect && this.clientsSelect.length !== 0) {
          return 'clear all'
        } else {
          return 'select all'
        }
      },
      getClients() {
        if (!this.checkValues()) {
          return []
        }
        /**
         * Calculate everything with a cloned object in order to not get render loops!
         */
        if (this.clientsSelect && this.clientsSelect.length) {
          let funds = this.tableValues
          // Clone of the selected clients
          this.computedClients = JSON.parse(JSON.stringify(this.clientsSelect))
          let allClientsCCY2 = new BigNumber(0)
          let allClientsAssetsSums = []
          // Total assets in base currency
          let totalBase = new BigNumber(0)
          // Total assets in base currency plus fees
          let totalBasePlusFee = new BigNumber(0)
          // Array total assets in base per customer
          let totalBaseArr = []
          // Array total assets in base per customer incl fees
          let totalBasePlusFeeArr = []
          // Total amount not included in percentage calculations
          let totalInBaseExcluded = new BigNumber(0)
          // Flag for any customers without an asset if not all of the asset is sold
          let notallsold = 0
          // Flag for any customers without an asset which is being bought
          let newbought = 0
          // Number of assets which must not be included in percentage calculations
          let notcounted = new BigNumber(0)
          /**
           Find out what the FX per asset is
           */
          JSON.parse(JSON.stringify(this.pricesSelect)).forEach((prices, i) => {
            // Calculate the final fx for this assets
            // We do it here cause we need it for the new total quantity in base asset
            if (funds[i + 1].ccy1 !== 0) {
              if (this.tableValues[i + 1].exchangeFeeValue !== this.tableValues[0].baseAsset) {
                funds[i + 1].fx = funds[i + 1].ccy2
                  ? new BigNumber(funds[i + 1].ccy2).abs()
                    .div(new BigNumber(funds[i + 1].ccy1).plus(funds[i + 1].exchangeFee).abs())
                  : 1
              } else {
                funds[i + 1].fx = parseFloat(funds[i + 1].ccy2)
                  ? (new BigNumber(funds[i + 1].ccy2).plus(funds[i + 1].exchangeFee))
                    .div(new BigNumber(funds[i + 1].ccy1)).abs()
                  : 1
              }
            }
          })

          /**
           * Iterate through the selected customers
           * for the first row of the base asset
           */
          this.computedClients.forEach((el, index) => {
            let totalInBase = new BigNumber(0)
            let totalInBasePlusFee = new BigNumber(0)
            let client = el.details
            if (!client.assets[this.baseAsset.ticker]) {
              client.assets[this.baseAsset.ticker] = {pieces: 0}
            }

            // Find the BEFORE values for the base asset
            client.baseAssetPieces = new BigNumber(client.assets[this.baseAsset.ticker].pieces)
            // Iterate through each selected asset (ccy2s)
            // in order to find the total new base asset quantity and prepare for share calculations later
            JSON.parse(JSON.stringify(this.pricesSelect)).forEach((prices, i) => {
              // If the client doesn't have the currency but it's completely sold
              // this currency should not be counted to the distribution of fees
              if (!client.assets[prices.symbol]) {
                if (parseFloat(funds[i + 1].after) === 0) {
                  notcounted = notcounted.plus(1)
                } else {
                  if (funds[i + 1].ccy1 < 0) {
                    notallsold = 1
                  } else {
                    newbought = 1
                  }
                }
              }
              // if the client doesn't have this currency
              if (!client.assets[prices.symbol]) {
                client.assets[prices.symbol] = {pieces: 0}
              } else {
                // Before value of the current asset if there is one
                client.pricesPieces[i] = client.assets[prices.symbol]
                  ? new BigNumber(client.assets[prices.symbol].pieces)
                  : new BigNumber(0)
                let weight = new BigNumber(client.pricesPieces[i]).div(funds[i + 1].before)
                let bfee = new BigNumber(funds[i + 1].blockchainFee).times(weight)
                // Sum up the new base asset quantity
                // Multiply the asset by the fx to find the new base asset quantity
                totalInBasePlusFee = totalInBasePlusFee.plus((new BigNumber(client.pricesPieces[i]).plus(bfee)).times(funds[i + 1].fx))
                totalInBase = totalInBase.plus((new BigNumber(client.pricesPieces[i])).times(funds[i + 1].fx))
              }
            })
            // Array of all base asset quantities per customer
            totalBaseArr[index] = totalInBase.plus(client.assets[this.baseAsset.ticker].pieces)
            totalBasePlusFeeArr[index] = totalInBasePlusFee.plus(client.assets[this.baseAsset.ticker].pieces)
            client.baseAssetEqual = totalBaseArr[index]
            // Total new base asset quantity
            totalBase = totalBase.plus(totalInBase).plus(client.assets[this.baseAsset.ticker].pieces)
            totalBasePlusFee = totalBasePlusFee.plus(totalInBasePlusFee).plus(client.assets[this.baseAsset.ticker].pieces)
            // Total in base excluded from calculations
            if (parseFloat(notcounted) === parseFloat(this.pricesSelect.length) && parseFloat(client.baseAssetPieces) === parseFloat(totalBaseArr[index])) {
              totalInBaseExcluded = totalInBaseExcluded.plus(totalBaseArr[index])
            }
          })
          /**
           * Iterate through the selected customers
           * the code before the assets loop is only for the first row
           */
          // calculate afters based on sums of ccy2s - custom case
          let calcaftersumccy2 = false
          this.computedClients.forEach((el, index) => {
            let client = el.details
            let sumofprod = new BigNumber(0)
            // Find the BEFORE values for the base asset
            client.baseAssetPieces = new BigNumber(client.assets[this.baseAsset.ticker].pieces)
            // Client percentage based on base asset
            client.percentage = parseFloat(totalBaseArr[index])
              ? totalBaseArr[index].div(totalBase)
              : new BigNumber(1)
            // Find out what percentage of the total currency position does the client have
            // so that we can calculate the resulting blockchain fee and after of the base asset
            if (parseFloat(client.baseAssetPieces) !== parseFloat(totalBaseArr[index])) {
              let assetpercentage = totalBasePlusFeeArr[index].div(totalBasePlusFee.minus(totalInBaseExcluded))
              // console.log(parseFloat(totalBasePlusFeeArr[index]) + ' ' + parseFloat(totalBasePlusFee))
              // console.log('notcounted ' + parseFloat(notcounted) + ' totalInBaseExcluded ' + parseFloat(totalInBaseExcluded) + ' newbought ' + parseFloat(newbought) + ' notallsold ' + parseFloat(notallsold) + ' ')
              // some customer doesn't have an asset and it's completely sold
              // TODO: calculate the after by summing up before with ccy2 ? maybe
              if (parseFloat(totalInBaseExcluded) !== 0) {
                // This is the asset-based percentage including fees when everything is sold
                client.blockchainFee = new BigNumber(funds[0].blockchainFee || 0).times(assetpercentage)
                client.after = (new BigNumber(funds[0].after || 0).minus(totalInBaseExcluded)).times(assetpercentage)
              // no currency is being excluded
              } else {
                // TODO: here should thing about an extension - the three currencies
                if (parseFloat(notallsold) !== 0) {
                  client.blockchainFee = new BigNumber(funds[0].blockchainFee || 0).times(client.percentage)
                  calcaftersumccy2 = true
                  // client.after = (new BigNumber(funds[0].after || 0)).times(client.percentage)
                } else {
                  // extremely custom case where one asset is completely sold and one asset is being newly bought
                  if (parseFloat(newbought) !== 0) {
                    client.blockchainFee = new BigNumber(funds[0].blockchainFee || 0).times(client.percentage)
                    calcaftersumccy2 = true
                    // client.after = (new BigNumber(funds[0].after || 0)).times(client.percentage)
                  } else {
                    // usual case - currencies being bought
                    // check if there is an excluded position in any client
                    if (parseFloat(notcounted) === 0) {
                      client.blockchainFee = new BigNumber(funds[0].blockchainFee || 0).times(client.percentage)
                      client.after = (new BigNumber(funds[0].after || 0)).times(client.percentage)
                    } else {
                      client.blockchainFee = new BigNumber(funds[0].blockchainFee || 0).times(client.percentage)
                      calcaftersumccy2 = true
                      // client.after = (new BigNumber(funds[0].after || 0)).times(assetpercentage)
                    }
                  }
                }
              }
            } else {
              if (parseFloat(notallsold) !== 0) {
                client.blockchainFee = new BigNumber(funds[0].blockchainFee || 0).times(client.percentage)
                client.after = (new BigNumber(funds[0].after || 0)).times(client.percentage)
              } else {
                // extremely custom case where one asset is completely sold and one asset is being newly bought
                calcaftersumccy2 = true
                if (parseFloat(newbought) !== 0) {
                  client.blockchainFee = new BigNumber(funds[0].blockchainFee || 0).times(client.percentage)
                  // calcaftersumccy2 = true
                  // client.after = (new BigNumber(funds[0].after || 0)).times(client.percentage)
                } else {
                  client.blockchainFee = new BigNumber(0)
                  client.after = totalBaseArr[index]
                }
              }
            }

            // count CCY2 for the check => BEFORE + BFee ( + all clients' CCY2)
            allClientsCCY2 = allClientsCCY2.plus(client.baseAssetPieces).plus(client.blockchainFee)
            /**
             * LOOP THROUGH ASSETS to generate the next rows
             */
            JSON.parse(JSON.stringify(this.pricesSelect)).forEach((prices, i) => {
              // BEFORE
              client.pricesPieces[i] = client.assets[prices.symbol]
                ? new BigNumber(client.assets[prices.symbol].pieces)
                : new BigNumber(0)
              // AFTER = FUND[AFTER] * PERCENTAGE
              client.afters[i] = new BigNumber(funds[i + 1].after || 0).times(client.percentage)

              // if client has SOME of that currency
              if (parseFloat(client.pricesPieces[i]) !== 0) {
                let assetpercentage = new BigNumber(client.pricesPieces[i]).div(funds[i + 1].before)
                // and it is being sold
                if (funds[i + 1].ccy1 < 0) {
                  // if not completely - those who have none of it will get some of it
                  if (parseFloat(notallsold) === 1) {
                    if (parseFloat(funds[i + 1].after) !== 0) {
                      client.blockchainFees[i] = new BigNumber(funds[i + 1].blockchainFee || 0).times(client.percentage)
                    } else {
                      client.blockchainFees[i] = new BigNumber(funds[i + 1].blockchainFee || 0).times(assetpercentage)
                    }
                  // if completely
                  } else {
                    // if there is a customer who is not going to be counted
                    if (parseFloat(notcounted) !== 0) {
                      client.blockchainFees[i] = new BigNumber(funds[i + 1].blockchainFee || 0).times(assetpercentage)
                    // standard case
                    } else {
                      client.blockchainFees[i] = new BigNumber(funds[i + 1].blockchainFee || 0).times(client.percentage)
                    }
                  }
                // if currency is bought
                } else {
                  client.blockchainFees[i] = new BigNumber(funds[i + 1].blockchainFee || 0).times(client.percentage)
                }
              // if client has NONE of that currency
              } else {
                // if it's being sold
                if (funds[i + 1].ccy1 < 0) {
                  // if not completely - those who have none of it will get some of it
                  if (parseFloat(notallsold) === 1 && parseFloat(funds[i + 1].after) !== 0) {
                    client.blockchainFees[i] = new BigNumber(funds[i + 1].blockchainFee || 0).times(client.percentage)
                  // if completely - there should be no fee
                  } else {
                    client.blockchainFees[i] = new BigNumber(0)
                  }
                // if currency is bought
                } else {
                  client.blockchainFees[i] = new BigNumber(funds[i + 1].blockchainFee || 0).times(client.percentage)
                }
              }
              // CCY1 = AFTER - BEFORE + BFee
              client.ccy1Arr[i] = client.afters[i].minus(client.pricesPieces[i]).minus(client.blockchainFees[i])
              // CCY2 = FUND[FX] * -CCY1
              client.ccy2Arr[i] = new BigNumber(funds[i + 1].fx).times(client.ccy1Arr[i] || 0).times(-1)
              // FX = CCY2 / CCY1
              client.fxArr[i] = Math.abs(client.ccy2Arr[i]
                ? client.ccy2Arr[i].div(client.ccy1Arr[i])
                : new BigNumber(0),
              )
              // Add + all clients' CCY2 to the check
              allClientsCCY2 = allClientsCCY2.plus(client.ccy2Arr[i])
              // FUND CHECK (summed for all clients) = BEFORE + CCY1 + BFee
              allClientsAssetsSums[i] = new BigNumber(client.pricesPieces[i])
                .plus(client.ccy1Arr[i])
                .plus(client.blockchainFees[i]).plus(allClientsAssetsSums[i] || 0)
              // After === CCY1 + B fee + Before
              client.afterCheck = client.afters[i].precision(8).eq(client.ccy1Arr[i].plus(client.blockchainFees[i]).plus(client.pricesPieces[i]).precision(8))
              // Add to summ of products
              sumofprod = sumofprod.plus((client.afters[i].times(client.fxArr[i])).minus(client.blockchainFees[i].times(client.fxArr[i])))
            })

            // CHECK CCY2 IN THE FIRST ROW OF A CLIENT'S TABLE
            let ccy2 = new BigNumber(0)
            client.ccy2Arr.forEach(el => {
              ccy2 = ccy2.plus(el)
            })
            if (client.ccy2Arr.length) {
              if (calcaftersumccy2) {
                client.after = new BigNumber(client.baseAssetPieces).plus(client.blockchainFee).plus(ccy2)
              }
              // console.log(client.baseAssetPieces.abs().toFixed(8) + ' ' + ccy2.abs().toFixed(8) + ' ' + client.after.abs().toFixed(8))
              // client.ccy2 = (client.baseAssetPieces.abs().precision(8).plus(client.blockchainFee).plus(ccy2.abs().precision(8))).eq(client.after.abs().precision(8))
              client.ccy2 = new BigNumber(client.baseAssetPieces.abs().toFixed(8))
                .plus(new BigNumber(client.blockchainFee).toFixed(8))
                .plus(new BigNumber(ccy2.abs().toFixed(8)))
                .eq(new BigNumber(client.after.abs().toFixed(8)))
            }
            sumofprod = sumofprod.plus(client.after.minus(client.blockchainFee))
            // console.log(parseFloat(sumofprod) + ' ' + parseFloat(client.baseAssetEqual))
            if (sumofprod.precision(8).eq(client.baseAssetEqual.precision(8))) {
              client.baseAssetCheck = true
            }
          })
          // CHECK FUNDS[0].Before + FUNDS[1+].CCY2 <= FUNDS[0].Before
          funds[0].checkLTE = new BigNumber(funds[0].before).plus(funds[0].blockchainFee).lte(Math.abs(funds[0].ccy1))
          // CHECK FUNDS[0].AFTER === CLIENTS[CCY2]
          funds[0].check = new BigNumber(allClientsCCY2.toFixed(8)).eq(new BigNumber(funds[0].after.toFixed(8)))
          // CHECK FUNDS[1+].AFTER === allClientsAssetsSums
          JSON.parse(JSON.stringify(this.pricesSelect)).forEach((prices, i) => {
            funds[i + 1].check = allClientsAssetsSums[i].precision(8).eq(new BigNumber(funds[i + 1].after).precision(8))
          })
          // Find out if there is a customer with faild baseAssetCheck
          if (this.computedClients.find(fruit => fruit.details.baseAssetCheck === false)) {
            this.checkbaseasseteq = false
          } else {
            this.checkbaseasseteq = true
          }

          // this.checkbaseasseteq = this.computedClients.find((id) => {
          // })

          this.canSubmit = true
          return this.computedClients
        }
      },
      getPrices() {
        return JSON.parse(JSON.stringify(this.pricesSelect))
      },
      getCsvTable() {
        if (!this.checkValues()) {
          return []
        }
        /**
         * Calculate everything with a cloned object in order to not get render loops!
         */
        let csv = null
        if (this.clientsSelect && this.clientsSelect.length) {
          csv = this.generateCSV(true)
          this.csvBreakpoints = []
          for (let i = 1; i < csv.length; i++) {
            this.csvBreakpoints[i] = csv[i][1] !== csv[i - 1][1]
          }
        } else {
          this.canSubmit = false
        }
        return csv
      },
      //   transactions() {
      //     return this.$store.getters.getSPTransactions
      //   },
      //   total() {
      //     return this.$store.getters.getSPTransactionsTotal
      //   },
      //   uploads() {
      //     return this.$store.getters.getRecentUploadsSummary
      //   },
    },
    created() {
      // this.loadRecentUploads()
      // axios.get(API_V1_URL + '/portfolio/0/tx')
      //   .then((res) => {
      //     console.log(res)
      //   })
      /**
       * Start loading
       */
      this.loading = true
      this.$store.dispatch('loadTotalPortfolios')
      /**
       * Load Portfolios
       */
        .then((data) => {
          let assets = this.$store.getters.getTPAssets
          assets.forEach((el) => {
            el.format = el.name + ' - ' + this.customFixed(el.pieces)
            this.currencies[el.name] = el
          })
          this.baseAssets = assets
        })
        /**
         * Load Prices
         */
        .then(() => {
          axios.get(API_V1_URL + '/prices/?limit=4000&offset=0')
            .then((res) => {
              let prices = []
              let fullPrices = []
              res.data.forEach((el) => {
                if (this.currencies[el.name]) {
                  el.format = el.id + ' [' + el.symbol + ']' + ' - ' + this.customFixed(this.currencies[el.name].pieces)
                  fullPrices.push(el)
                } else {
                  let elem = Object.assign({}, el)
                  let baseassetelem = Object.assign({}, el)
                  if (elem.id !== 'eur' && elem.id !== 'usd' && elem.id !== 'bgn') {
                    baseassetelem.ticker = baseassetelem.symbol
                    baseassetelem.format = baseassetelem.name + ' - ' + this.customFixed('0')
                    this.baseAssets.push(baseassetelem)
                    elem.format = elem.id + ' [' + elem.symbol + ']' + ' - ' + this.customFixed('0')
                    elem.ticker = elem.symbol
                    delete elem.symbol
                    this.currencies[elem.name] = elem
                  }
                  el.format = el.id + ' [' + el.symbol + ']'
                  prices.push(el)
                }
              })
              this.pricesSelectArr = fullPrices.concat(prices)
            })
        })
        /**
         * Load Clients
         */
        .then(() => {
          axios.get(API_V1_URL + '/users?role=client&offset=0&limit=1000')
            .then((res) => {
              res.data.forEach((el) => {
                el.fullName = el.firstName + ' ' + el.lastName + ' [' + el.clientId + ']'
                el.details = {
                  assets: {},
                  after: 0,
                  baseAssetPieces: 0,
                  baseAssetEqual: 0,
                  baseAssetCheck: false,
                  pricesPieces: [],
                  percentage: 0,
                  blockchainFees: [],
                  afters: [],
                  ccy1Arr: [],
                  ccy2Arr: [],
                  fxArr: [],
                }
                this.clients[el.id] = el
              })
            })
            /**
             * Load Portfolio data
             */
            .then(() => {
              let requests = Object.keys(this.clients).map((id) => {
                let ids = []
                this.clients[id].portfolios.forEach(function(portfolio) {
                  ids.push(axios.get(API_V1_URL + '/portfolio/' + portfolio.id + '/data/noroi'))
                })
                return ids
              })
              // Search in all assets
              let reqs = [].concat(...requests)
              axios.all(reqs)
                .then((responses) => {
                  this.portfolios = responses
                })
                /**
                 * Stop loading
                 */
                .finally(() => {
                  this.loading = false
                })
            })
        })
    },
    methods: {
      /**
       * Select all clients link
       */
      checkAll() {
        if (this.selectall !== 'clear all') {
          this.clientsSelect = []
          this.clientsSelectArr.forEach((el) => {
            this.onSelectClient(el)
            this.clientsSelect.push(el)
          })
        } else {
          this.clientsSelect.forEach((el) => {
            this.onRemoveClient(el)
          })
          this.clientsSelect = []
        }
      },
      copyToClipboard(elementId) {
        const temp = document.createElement('input')
        const text = elementId
        temp.setAttribute('value', text)
        document.body.appendChild(temp)
        temp.select()
        document.execCommand('copy')
        document.body.removeChild(temp)
      },
      /**
       * Reset some values in order to not have bugs
       */
      onSelectBaseAsset(value) {
        // Prepare table
        this.tableValues[0].isSelected = false
        this.tableValues[0].baseAsset = this.currencies[value.name].ticker
        // Make sure the user can't select the same prices
        let found = this.pricesSelectArr.find(function(el) {
          return el['$isDisabled'] === true
        })
        if (found) {
          found['$isDisabled'] = false
        }
        let found2 = this.pricesSelectArr.find(function(el) {
          return value.ticker === el.symbol
        })
        if (found2) {
          found2['$isDisabled'] = true
        }
        // Reset values
        if (this.clientsSelect && this.clientsSelect.length) {
          for (let values of this.tableValues) {
            values.before = 0
          }
          this.clientsSelect.forEach((el) => {
            this.onSelectClient(el)
          })
        }
        if (this.pricesSelect) {
          this.tableValues.forEach(function(el, i) {
            if (i) {
              el.price = 0
            }
          })
          for (let [key, price] of Object.entries(this.pricesSelect)) {
            if (key !== this.tableValues[0].symbol) {
              this.onSelectPrice(price, 0, true)
            }
          }
        }
        this.generateReqs(value)
      },
      /**
       * Load Clients who have the currency in their assets
       */
      generateReqs(value) {
        let clients = []
        let pricesSelect = this.pricesSelect ? this.pricesSelect.slice() : []
        this.portfolios.forEach((res) => {
          this.assets[res.data.userId] = res.data.assets
          for (let asset of res.data.assets) {
            if (asset.name === value.name ||
              pricesSelect.findIndex((el) => el.name === asset.name) !== -1
            ) {
              let client = this.clients[res.data.userId]
              if (clients.findIndex(el => el === client) === -1) {
                const hasNoMoney = this.assets[res.data.userId].every(el => {
                  return (this.customFixed(el.pieces, 8) < 0.000001)
                })
                if (!hasNoMoney) {
                  clients.push(client)
                }
              }
            }
          }
        })
        clients.sort((a, b) => a.fullName.localeCompare(b.fullName))
        this.clientsSelectArr = clients
        this.loading = false
        // Show the table
        this.tableValues[0].isSelected = true
      },
      /**
       * Client select methods
       */
      onSelectClient(value) {
        for (let portfolio of this.assets[value.id]) {
          this.tableValues.forEach((el) => {
            if (portfolio.ticker === el.baseAsset) {
              el.before = new BigNumber(portfolio.pieces).plus(new BigNumber(el.before))
              value.details['assets'][el.baseAsset] = portfolio
            }
          })
        }
        this.onInput()
      },
      onRemoveClient(value) {
        for (let portfolio of this.assets[value.id]) {
          this.tableValues.forEach(function(el) {
            if (portfolio.ticker === el.baseAsset) {
              el.before = new BigNumber(el.before).minus(portfolio.pieces)
              delete value.details['assets'][el.baseAsset]
            }
          })
        }
        this.onInput()
      },
      /**
       * Price select methods
       */
      onSelectPrice(value, id, hasBaseAssetChanged) {
        // Make sure the user can't select the same assets
        Object.keys(this.currencies).forEach((key) => {
          if (value.symbol === this.currencies[key].ticker) {
            this.currencies[key]['$isDisabled'] = !this.currencies[key]['$isDisabled']
          }
        })
        let options = [value.symbol, this.tableValues[0].baseAsset]
        // Create new row
        if (!hasBaseAssetChanged) {
          this.tableValues.push({
            baseAsset: value.symbol,
            before: 0,
            ccy1: 0,
            ccy2: 0,
            exchangeFee: 0,
            fx: 0,
            blockchainFee: 0,
            after: 0,
            coldStorage: 0,
            csCheck: '',
            check: '',
            exchangeFeeValue: options[0],
            exchangeFeeOptions: options,
          })
        }
        /**
         * Calculate "before" field for each client
         */
        if (this.clientsSelect) {
          for (let [, client] of Object.entries(this.clientsSelect)) {
            for (let portfolio of client.portfolios) {
              let found = this.assets[portfolio.userId].find(function(el) {
                return el.ticker === value.symbol
              })
              if (found) {
                for (let row of this.tableValues) {
                  if (row.baseAsset === value.symbol) {
                    row.before = new BigNumber(found.pieces).plus(row.before)
                    client.details['assets'][value.symbol] = found
                  }
                }
              }
            }
          }
        }
        this.generateReqs(this.baseAsset)
      },
      onRemovePrice(value) {
        // Make sure the user can't select the same assets
        Object.keys(this.currencies).forEach((key) => {
          if (value.symbol === this.currencies[key].ticker) {
            this.currencies[key]['$isDisabled'] = !this.currencies[key]['$isDisabled']
          }
        })
        // Remove row from fund table
        this.tableValues.splice(this.tableValues.findIndex(val => {
          return val.baseAsset === value.symbol
        }), 1)
        this.generateReqs(this.baseAsset)
        this.onInput()
      },
      /**
       * Calculations
       */
      onInput(e) {
        if (e && e.target) {
          if (!RegExp('^-?[0-9]+([\\.][0-9]+)?$').test(e.target.value)) {
            e.target.value = e.target.value.replace(',', '.')
            e.target.closest('td').classList.add('table-danger')
          } else {
            e.target.closest('td').classList.remove('table-danger')
          }
        }

        if (this.checkValues()) {
          // CCY1 Calculate
          this.tableValues[0].ccy1 = 0
          this.tableValues.forEach((el, i) => {
            if (i) {
              this.tableValues[0].ccy1 = new BigNumber(this.tableValues[0].ccy1 || 0).plus(el.ccy2 || 0)
            }
          })

          // AFTER Calculate
          let sumCCY2 = 0
          this.tableValues.forEach((el, i) => {
            if (i) {
              sumCCY2 = new BigNumber(parseFloat(sumCCY2)).plus(el.ccy2)
            }
          })
          this.tableValues[0].after = new BigNumber(this.tableValues[0].before || 0).plus(parseFloat(sumCCY2) || 0).plus(this.tableValues[0].blockchainFee || 0).precision(14)
          this.tableValues.forEach((el, i) => {
            if (i) {
              sumCCY2 = new BigNumber(parseFloat(sumCCY2)).plus(el.ccy2)
              this.tableValues[i].after = new BigNumber(el.before).plus(el.ccy1).plus(el.blockchainFee) || 0
              if (this.tableValues[i].exchangeFeeValue !== this.tableValues[0].baseAsset) {
                // FUND[i].AFTER = Before + CCY1 + ExchangeFee
                this.tableValues[i].after = new BigNumber(this.tableValues[i].after).plus(el.exchangeFee || 0)
              } else {
                // FUND[0].AFTER += FUND[i].ExchangeFee
                this.tableValues[0].after = new BigNumber(this.tableValues[0].after).plus(this.tableValues[i].exchangeFee || 0)
              }
              // Negative value check
              if (this.tableValues[i].after < 0) { this.tableValues[i].checkneg = 1 } else { this.tableValues[i].checkneg = false }
              // Cold storage check
              this.tableValues[i].csCheck = new BigNumber(this.tableValues[i].coldStorage.toFixed(8)).eq(new BigNumber(this.tableValues[i].after.toFixed(8)))
            }
          })
          // Cold storage check for base asset
          // console.log(this.tableValues[0].coldStorage.toFixed(8) + ' = ' + this.tableValues[0].after.toFixed(8))
          this.tableValues[0].csCheck = new BigNumber(this.tableValues[0].coldStorage.toFixed(8)).eq(new BigNumber(this.tableValues[0].after.toFixed(8)))
          // Negative value check
          if (this.tableValues[0].after < 0) { this.tableValues[0].checkneg = 1 } else { this.tableValues[0].checkneg = false }
        }
      },
      customFixed(str, num = 8) {
        const rgx = new RegExp(`-?\\d+\\.?\\d{0,${num}}`)
        str = (`${str}`).match(rgx)
        return str ? parseFloat(str[0]).toFixed(num) : parseFloat(0).toFixed(num)
      },
      customFormatter(date) {
        return moment(date).format('DD.MM.YYYY')
      },
      onSubmit(e) {
        const ans = confirm('Are you sure you want to submit the transactions?')
        if (!ans) {
          return
        }

        this.loading = true

        let fd = new FormData()
        fd.append('file', new File(
          [new Blob([this.generateCSV()], {type: 'text/csv;charset=utf-8'})],
          `Rebalance-${this.customFormatter(this.date)}.csv`,
          {type: 'text/csv'},
        ))

        uploadService.uploadCSV(fd)
          .then(() => {
            this.$parent.showModal = true
          })
          .catch(errRes => {
            this.errMsg = errRes.error
          })
          .finally(() => {
            this.loading = false
          })
      },
      generateCSV(notParsed) {
        let transactionId = parseFloat(this.transactionId) || 0
        const date = this.customFormatter(this.date)
        const rows = [
          ['Date', 'Counterparty', 'Client ID', 'Portfolio ID', 'Transaction ID', 'Type', 'Currency 1 Amount', 'Currency 1', 'Currency 2 Amount', 'Currency 2'],
        ]
        for (let client of this.computedClients) {
          // Fees
          // console.log(this.customFixed(client.details.blockchainFee, 14))
          if (parseFloat(client.details.blockchainFee) !== 0) {
            rows.push([
              date,
              `${client.firstName} ${client.lastName}`,
              client.clientId,
              client.portfolios[0].id,
              transactionId++,
              'blockchain fee',
              this.customFixed(client.details.blockchainFee, 14),
              this.tableValues[0].baseAsset,
              '',
              '',
            ])
          }

          client.details.pricesPieces.forEach((el, i) => {
            // console.log(this.customFixed(client.details.blockchainFees[i], 14))
            if (parseFloat(client.details.blockchainFees[i]) !== 0) {
              rows.push([
                date,
                `${client.firstName} ${client.lastName}`,
                client.clientId,
                client.portfolios[0].id,
                transactionId++,
                'blockchain fee',
                this.customFixed(client.details.blockchainFees[i], 14),
                this.tableValues[i + 1].baseAsset,
                '',
                '',
              ])
            }
          })
          // Changes
          client.details.pricesPieces.forEach((el, i) => {
            if (parseFloat(client.details.ccy1Arr[i]) !== 0) {
              rows.push([
                date,
                `${client.firstName} ${client.lastName}`,
                client.clientId,
                client.portfolios[0].id,
                transactionId++,
                'change',
                this.customFixed(client.details.ccy1Arr[i], 14),
                this.tableValues[i + 1].baseAsset,
                // this.customFixed(client.details.ccy2Arr[i], 14),
                parseFloat(client.details.ccy2Arr[i]).toFixed(14),
                this.tableValues[0].baseAsset,
              ])
            }
          })
        }
        return notParsed ? rows : Papa.unparse(rows, {delimiter: ','})
      },
      downloadCSV(e) {
        e.preventDefault()
        FileSaver.saveAs(
          new Blob([this.generateCSV()], {type: 'text/csv;charset=utf-8'}),
          `Rebalance-${this.customFormatter(this.date)}.csv`,
        )
      },
      checkValues() {
        let result = true
        this.tableValues.forEach((row, i) => {
          if (!i && (isNaN(parseFloat(row.blockchainFee)) || isNaN(parseFloat(row.coldStorage)))) {
            result = false
          } else if (
            isNaN(parseFloat(row.ccy1)) || isNaN(parseFloat(row.ccy2)) || isNaN(parseFloat(row.exchangeFee)) ||
            isNaN(parseFloat(row.blockchainFee)) || isNaN(parseFloat(row.coldStorage))
          ) {
            result = false
          }
        })
        return result
      },
      downloadTransactions(e) {
        e.preventDefault()

        const rows = [
          ['Asset', 'Before', 'CCY1', 'CCY2', 'Exchange fee', 'FX', 'B Fee', 'After', 'Cold storage', ''],
        ]

        // Fees
        for (let row of this.tableValues) {
          rows.push([
            row.baseAsset,
            // parseFloat(row.before).toFixed(9),
            this.customFixed(parseFloat(row.before).toFixed(14), 14),
            this.customFixed(row.ccy1, 14),
            this.customFixed(row.ccy2, 14),
            this.customFixed(row.exchangeFee, 14),
            this.customFixed(row.fx, 14),
            this.customFixed(row.blockchainFee, 14),
            this.customFixed(parseFloat(row.after).toFixed(14), 14),
            this.customFixed(row.coldStorage, 14),
          ])
        }

        rows.push([])
        rows.push(['', '', '', '', '', '', '', '', '', this.remark])

        FileSaver.saveAs(
          new Blob([Papa.unparse(rows, {delimiter: ','})], {type: 'text/csv;charset=utf-8'}),
          `input-transactions-${this.customFormatter(this.date)}.csv`,
        )
      },
      // loadRecentUploads() {
      //   let self = this
      //   this.$store.dispatch('loadRecentUploadsSummary')
      //     .then(uploads => {
      //       window.clearTimeout(self.timeoutID)
      //       const hasUnprocessedFile = uploads.find(upload => upload.status === 'pending' || upload.status === 'working')
      //       if (hasUnprocessedFile) {
      //         self.timeoutID = window.setTimeout(self.loadRecentUploads, 1000)
      //       }
      //     })
      // },
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

    .w-100 {
        min-width: 0;
    }

    .input-group-addon {
        padding: 0.375rem;
        font-size: 0.9rem;
    }

    td .timestiselect {
        width: 5rem;
    }

    td .timestiselect__single {
        font-size: 0.9em;
    }

    table {
        min-width: 1280px;
    }

    .basicinfo >>> .vdp-datepicker input {
        padding: 0.375rem 0.75rem !important;
        border: 1px solid #e8e8e8;
        border-radius: 0.25rem;
        font-size: 1rem;
        line-height: 1.5;
    }

    .basicinfo >>> .timestiselect__placeholder {
        margin-bottom: 0;
    }

    .basicinfo >>> .timestiselect__tag {
        margin-bottom: 0;
    }

    .basicinfo >>> .timestiselect__tags {
        font-size: 16px;
        margin-bottom: 0;
        line-height: 25px;
        padding: 5px 40px 0 10px !important;
    }

    .exchangefee >>> .timestiselect__tags {
        border-radius: 5px 0 0 5px;
    }

    #assets {
        font-size: 14px;
    }

    .basicinfo >>> .timestiselect--disabled {
        opacity: 1;
    }

    .basicinfo >>> .form-control {
        border: 1px solid #e8e8e8;
    }

    .basicinfo >>> .timestiselect__single,
    .basicinfo >>> .timestiselect__input {
        line-height: 28px;
        padding-left: 0;
        margin-bottom: 0px;
    }

    table.inputtrans td, table.inputtrans th {
        vertical-align: middle;
    }

    .copytoclip {
      width: 36px;
    }

    .copytoclip > span:nth-child(2),
    .copytoclip:hover > span:nth-child(1) {
      display: none;
    }
    .copytoclip:hover > span:nth-child(2) {
      display: block;
    }

    @media only screen and (max-width: 1280px) {
        .list-group-item {
            border: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/-service-app/components/forms/RebalanceForm.vue